import { useEffect, useState } from "react";
import { X } from "lucide-react";

export default function Popup({ popups }) {
  const [active, setActive] = useState(null);

  useEffect(() => {
    if (!popups || popups.length === 0) return;
    const p = popups[0];
    const key = `shruti_popup_${p.id}`;
    if (p.frequency === "session" && sessionStorage.getItem(key)) return;
    if (p.frequency === "once" && localStorage.getItem(key)) return;
    const delay = (parseFloat(p.showDelay) || 3) * 1000;
    const t = setTimeout(() => {
      setActive(p);
      if (p.frequency === "session") sessionStorage.setItem(key, "1");
      if (p.frequency === "once") localStorage.setItem(key, "1");
    }, delay);
    return () => clearTimeout(t);
  }, [popups]);

  if (!active) return null;
  const go = (href) => {
    setActive(null);
    if (href?.startsWith("#")) document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div data-testid="site-popup" className="fixed inset-0 z-[70] bg-black/60 backdrop-blur-sm flex items-center justify-center p-5" onClick={() => setActive(null)}>
      <div onClick={(e) => e.stopPropagation()} className="relative bg-[var(--c-bg)] rounded-3xl overflow-hidden max-w-md w-full border border-[var(--c-border)] shadow-2xl">
        <button onClick={() => setActive(null)} className="absolute top-3 right-3 z-10 grid place-items-center h-9 w-9 rounded-full bg-black/30 text-white hover:bg-black/50"><X className="h-5 w-5" /></button>
        {active.image && <img src={active.image} alt={active.heading} className="w-full h-48 object-cover" />}
        <div className="p-7 text-center">
          <h3 className="font-heading text-2xl font-bold text-[var(--c-primary)]">{active.heading}</h3>
          <p className="font-body text-[var(--c-muted)] mt-3 leading-relaxed">{active.text}</p>
          {active.buttonLabel && (
            <button onClick={() => go(active.buttonHref)} className="mt-6 rounded-full bg-[var(--c-primary)] text-white font-body font-medium px-8 py-3 hover:bg-[var(--c-secondary)] transition-colors">
              {active.buttonLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
